/**
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Preview Again Import dialog component
  Date: April 25, 2020
**/

import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  DialogContent,
  DialogActions,
  Dialog,
  DialogTitle,
  Button,
  Tooltip,
  IconButton,
  Typography
} from '@material-ui/core';
import { DataGrid } from "@material-ui/data-grid";
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useStoreActions } from 'easy-peasy';
import { PRODUCTS } from '../../submodule/constants/applicationConstants';
import useCommonAuth from '../../submodule/hooks/useCommonAuth';
// import { EnhancedTable } from '..';

const ImportPreviewDialog = (props) => {
  const { onClose, open, previewData } = props;
  const {userModulePermissions} = useCommonAuth();
  const importAction = useStoreActions((actions) => actions.import);
  const { formattedGridData = {} } = previewData;
  const handleCancel = () => {
    onClose(null);
  };
  //Submit dialog popup
  const handleImport = () => {
    onClose(previewData.job_id);
  };

  const handleDownload = () => {
    importAction
      .getPreSignedUrl({
        filename: previewData?.job?.file_path,
        operation_type: 'DOWNLOAD',
      })
      .then(function (response) {
        window.open(response.data.data.url);
      })
      .catch(function (error) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: stringConstants.fileDownloadFailureMsg,
          error: true,
        });
      });
  };

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      maxWidth="md"
      aria-labelledby="confirmation-dialog-title"
      open={open}
      PaperProps={{
        style: { borderRadius: 20 }
      }}
    >
      <DialogTitle id="confirmation-dialog-title">
        <Grid container justify="space-between">
          <Typography variant="h6" component="h6">Preview</Typography>
          <Tooltip title="Download File">
            <IconButton
              style={{padding: '0px'}}
              color="primary"
              aria-label="Add"
              onClick={handleDownload}
            >
              <CloudDownloadIcon style={{ fontSize: '3.9vh' }}></CloudDownloadIcon>
            </IconButton>
          </Tooltip>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={12} style={{ overflowY: 'auto' }}>
            <div style={{ height: '50vh', width: formattedGridData.columns ? (formattedGridData.columns.length > 2 ? '55vw' : '35vw') : '35vw' }}>
              <DataGrid
                rowsPerPageOptions={[]}
                columns={formattedGridData.columns ? formattedGridData.columns : []}
                rows={formattedGridData.data ? formattedGridData.data : []}
                getRowId={(row) => {
                  return row.id;
                }}
              >
              </DataGrid>
              {/* <EnhancedTable
                columns={formattedGridData.columns ? formattedGridData.columns : []}
                data={formattedGridData.data ? formattedGridData.data : []}>

              </EnhancedTable> */}
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          style={{marginTop: '10px'}}
        >
          <Grid item>
            <Button onClick={handleCancel} variant="contained" color="secondary">
              Cancel
            </Button>
          </Grid>
          {userModulePermissions('import_job', 'add', PRODUCTS.MAINAPP) && (
            <Grid item>
              <Button
                autoFocus
                variant="contained"
                onClick={handleImport}
                color="primary"
              >
                Import
              </Button>
            </Grid>
          )}
        </Grid>
    </DialogActions>
    </Dialog>
  );
};
ImportPreviewDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};
export default ImportPreviewDialog;
